import '../scss/main.scss'
import Theme from './components/theme'
import '@babel/polyfill'

Drupal.behaviors.theme = {
  attach() {
    new Theme()
  },
}
